export const RESIZE_DRAG_THRESHOLD_PX = 3

/**
 * A pointerdown/pointerup on the resize handle without real movement must not
 * freeze the current auto width into the saved column settings.
 */
export function isResizeDrag(startX: number, endX: number): boolean {
  return Math.abs(endX - startX) >= RESIZE_DRAG_THRESHOLD_PX
}

/**
 * Whether a pointer move should resize the column: nothing is applied until the
 * pointer has crossed the drag threshold once, then every move is applied.
 */
export function shouldApplyResize(
  isDragging: boolean,
  startX: number,
  currentX: number
): boolean {
  return isDragging || isResizeDrag(startX, currentX)
}

export function buildCellWidths(
  columns: Array<{ visual?: { width?: number | string | null } | null }>
): Record<number, number | 'auto'> {
  return Object.fromEntries(
    columns.map((column, index) => {
      const width = Number(column.visual?.width)
      return [index, Number.isFinite(width) && width > 0 ? width : 'auto']
    })
  )
}
